exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ul[data-v-73bedad2]{list-style:none;padding:0}img[data-v-73bedad2]{width:100%;border-radius:.2%;margin-top:1.45em;padding-bottom:15px;-webkit-filter:grayscale(.3);filter:grayscale(.3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-73bedad2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/HomePage.vue
// module id = 20
// module chunks = 0